const bleeding=[

    {
    label:"Site(s) of bleeding",
    controlType:"text area",
    options:[]
    },

    { 
    label:"Amount of bleeding:",
    controlType:"radio button",
    options:["Slight", "Moderate", "Heavy"],
    },

    { 
    label:"Type of blood:",
    controlType:"checkbox group",
    options:["Fresh blood", "Dark blood"],
    },

    {
    label:"Frequency",
    controlType:"radio button",
    options:["Every day", "Most days", "Every week or two", "Occasionally"]
    },

    { 
    label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
]

export default bleeding